/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-telegram': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 2a10 10 0 100 20 10 10 0 000-20zm5.3 5.963l-1.915 8.819c-.134.627-.521.778-1.056.489l-2.914-2.107-1.4 1.329a.75.75 0 01-.584.289l.2-2.912 5.407-4.764c.239-.213-.049-.317-.366-.131L7.993 13.1l-2.886-.9c-.62-.172-.627-.592.141-.9L16.49 7.068c.51-.227 1.01.124.81.895z" _fill="#000"/>'
  }
})
